// extracted by mini-css-extract-plugin
export var label = "_hp-2";
export var slideContainer = "_hp-0";
export var slider = "_hp-1";